import { render, staticRenderFns } from "./TheShow.vue?vue&type=template&id=5b223bca&scoped=true&"
import script from "./TheShow.vue?vue&type=script&lang=js&"
export * from "./TheShow.vue?vue&type=script&lang=js&"
import style0 from "./TheShow.vue?vue&type=style&index=0&id=5b223bca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b223bca",
  null
  
)

export default component.exports